import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AboutCTA: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="bg-gradient-to-br from-teal-600 to-[#0A1628] py-24">
      <div className="max-w-4xl mx-auto px-6 text-center">
        <h2 className="text-3xl font-bold text-white tracking-tight">{t('aboutPageSection.cta.title')}</h2>
        <p className="text-white/50 mt-4 max-w-xl mx-auto font-light">
          {t('aboutPageSection.cta.description')}
        </p>
        <Link
          to="/contact"
          className="inline-flex items-center justify-center bg-white text-teal-700 font-semibold px-8 py-4 transition-all text-sm mt-8 hover:shadow-xl hover:-translate-y-0.5"
        >
          {t('aboutPageSection.cta.button')}
        </Link>
      </div>
    </section>
  );
};

export default AboutCTA;
